// The colors players are shown in: blue, red, green and yellow, by seat. A player who has picked a color of their own
// (on their profile) sees themselves in it, in every game, and the others in the rest, in seat order; so the colors are
// the viewer's own, and the game never names one.
export const Colors = ['Blue', 'Red', 'Green', 'Yellow'];
// (names in text: readable on white)
const Text = { Blue: 'Blue', Red: 'Red', Green: 'Green', Yellow: '#8B8000' };
// (a board's border and its tab)
const Strong = { Blue: 'blue', Red: 'red', Green: 'green', Yellow: '#e6c200' };

// Each seat's color, as the viewer sees it; mySeat: theirs (-1: not in the game), preferred: their color (null: none)
export const SeatColors = (count, mySeat = -1, preferred = null) => {
    const own = mySeat >= 0 && mySeat < count && Colors.includes(preferred) ? preferred : null;
    const rest = Colors.filter(color => color !== own);
    return Array.from({ length: count }, (_, seat) => seat === mySeat && own ? own : rest.shift());
};
export const ColorText = (color) => Text[color] ?? '#555';
export const ColorStrong = (color) => Strong[color] ?? '#555';
// A seat's color for names, by seat or from the viewer's colors (SeatColors)
export const SeatColor = (seat, colors = null) => ColorText(colors?.[seat] ?? Colors[seat]);
